module.exports = __webpack_public_path__ + "img/icon-change-password.c802258b.svg";